module.exports = __webpack_public_path__ + "static/media/notificaiton_without_dot.44400861.svg";